// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-view[data-v-eb65d5d4]{position:relative;height:100%}.slide-view__item[data-v-eb65d5d4]{position:absolute;top:0;left:0;z-index:10;width:100%;height:100%;background-color:#000;opacity:0;-webkit-transition:opacity 1.5s ease-in-out;-o-transition:opacity 1.5s ease-in-out;-moz-transition:opacity 1.5s ease-in-out;transition:opacity 1.5s ease-in-out;overflow:hidden}.slide-view__item.is-visible[data-v-eb65d5d4]{opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
